"use client"
import "./CleanButton.scss"

const CleanButton = ({
  children,
  variant = "primary",
  size = "md",
  icon,
  onClick,
  disabled = false,
  className = "",
  ...props
}) => {
  const buttonClasses = ["clean-btn", `clean-btn--${variant}`, `clean-btn--${size}`, className]
    .filter(Boolean)
    .join(" ")

  return (
    <button className={buttonClasses} onClick={onClick} disabled={disabled} {...props}>
      {icon && <span className="clean-btn__icon">{icon}</span>}
      <span className="clean-btn__text">{children}</span>
    </button>
  )
}

export default CleanButton
